import MonacoEditor, { useMonaco } from '@monaco-editor/react';
import { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

import { useTheme } from '../../hooks';
import { IEditor } from '../../interfaces';
import { defineTheme, nithinpbdotcom, initialOptions } from './variables'
import './index.scss'


export default function Editor(props: IEditor) {
    const { value, onValueChange, readOnly, language, editorRef, options } = { ...props }
    const editorOptions = initialOptions(options)
    const { mode } = useTheme()
    const monacoInstance = useMonaco()

    const handleOnMount = (editor: any, monaco: any) => {
        editorRef.current = editor;
        if (monacoInstance) {
            monacoInstance.editor.setTheme(nithinpbdotcom.name)
        }

    }

    useEffect(() => {
        //monacoInstance?.editor.updateOptions(initialOptions(options))
        //@ts-ignore
        editorRef?.current?.updateOptions(initialOptions(options))
        //setOptions()
    }, [options])

    useEffect(() => {
        if (monacoInstance) {
            defineTheme(monacoInstance, mode)
            monacoInstance.editor.setTheme(nithinpbdotcom.name)
        }

        document.fonts.ready.then(() => {
            monacoInstance?.editor.remeasureFonts()
        })
    }, [monacoInstance, mode])

    return (
        <div className='h-full Editor-Container'>
            <MonacoEditor
                onMount={handleOnMount}
                options={editorOptions}
                height={'100%'}
                onChange={(value: any) => onValueChange(value)}
                loading={<NoteLoading />}
                theme={nithinpbdotcom.name}
                language={language}
                value={value}
                defaultLanguage={language || 'plaintext'}
                defaultValue={value} />
        </div>
    )
}


function NoteLoading() {
    return (
        <Box display={'flex'} gap={1.5} alignItems={'center'}>
            <CircularProgress size={'20px'} thickness={7} />
            <Typography>
                Note preparing...
            </Typography>
        </Box>
    )
}